// extracted by mini-css-extract-plugin
export var aircallIframe = "_ij-3";
export var fabContainer = "_ij-5";
export var fabRinging = "_ij-6";
export var loadingOverlay = "_ij-4";
export var pulse = "_ij-7";
export var widgetContent = "_ij-2";
export var widgetPanel = "_ij-0";
export var widgetPanelExpanded = "_ij-1";